/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsThreadColor
 */
export interface SharedserviceMelcoModelsThreadColor {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsThreadColor
     */
    argb?: string | null;
}

export function SharedserviceMelcoModelsThreadColorFromJSON(json: any): SharedserviceMelcoModelsThreadColor {
    return SharedserviceMelcoModelsThreadColorFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsThreadColorFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsThreadColor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'argb': !exists(json, 'argb') ? undefined : json['argb'],
    };
}

export function SharedserviceMelcoModelsThreadColorToJSON(value?: SharedserviceMelcoModelsThreadColor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'argb': value.argb,
    };
}


